<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>兑换码>使用记录</div>
		<div class="title">
			<div class="left">
				{{ plan.name }}
			</div>
			<div class="right">
				<el-select v-model="filter.status" style="width: 150px;margin-right: 20px;" size="small">
					<el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" v-model="filter.name" style="width: 200px;margin-right: 20px;"
					size="small"></el-input>
				<el-button type="primary" size="small" @click="getData(), filter.pageNum=1">筛选</el-button>
				<el-button type="primary" size="small" style="margin-left: 20px;" @click="downUse()">导出数据</el-button>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="list" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
				style="width: 100%">
				<el-table-column prop="exchange" align="center" label="兑换码"></el-table-column>
				<el-table-column label="用户头像" prop="avatarUrl" align="center" width="200">
					<template slot-scope="scope">
						<el-avatar :size="50" :src="scope.row.avatarUrl">
							<img src="../../../assets/headerhz.png" />
						</el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickName" align="center" label="用户名称">
					<template slot-scope="scope">
						{{scope.row.nickName || "/"}}
					</template>
				</el-table-column>
				<el-table-column prop="telphone" align="center" label="用户手机">
					<template slot-scope="scope">
						{{scope.row.telphone || "/"}}
					</template>
				</el-table-column>
				<el-table-column align="center" label="使用状态">
					<template slot-scope="scope">
						<span>{{scope.row.status | statusFormat}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" label="使用时间">
					<template slot-scope="scope">
						{{scope.row.useTime || "/"}}
					</template>
				</el-table-column>
				<el-table-column prop="name7" align="center" label="链接">
					www.ciaojian.com
				</el-table-column>
			</el-table>
			<el-pagination background @current-change="clickPage" @size-change="handleSizechange"
				style="margin-top: 30px;" layout="sizes, prev, pager, next" :current-page="filter.pageNum"
				:page-size="filter.pageSize" :total="filter.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../../utils/index.js"
	export default {
		data() {
			return {
				url: url(),
				plan: undefined,
				statusList: [{
					label: "全部状态",
					value: -1,
				}, {
					label: "未使用",
					value: 0,
				}, {
					label: "已使用",
					value: 1,
				}, {
					label: "已失效",
					value: 2,
				}, ],
				list: [],
				filter: {
					id: undefined,
					name: undefined,
					status: -1,
					pageNum: 1,
					pageSize: 10,
					total: 0,
				},
			}
		},
		mounted() {
			this.plan = this.$route.query;
			this.filter.id = this.plan.id
			this.getData();
		},
		filters: {
			statusFormat(val) {
				switch (val) {
					case 0:
						return "未使用";
					case 1:
						return "已使用";
					case 2:
						return "已失效";
				}
			}
		},
		methods: {
			downUse() {
				let urls = "id=" + this.filter.id;
				if (this.filter.name) urls += "&name=" + this.filter.name;
				if (this.filter.status) urls += "&status=" + this.filter.status;
				window.location.assign(this.url + "codePlan/downUse?" + urls);
			},
			clickPage(val) {
				this.filter.pageNum = val;
				this.getData();
			},
			getData() {
				this.$http.post("codePlan/codeList", JSON.stringify(this.filter)).then(res => {
					this.list = res.body.data;
					this.filter.total = res.body.total;
				})
			},
			handleSizechange(val) {
				this.filter.pageSize = val;
				this.getData();
			}
		},
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}
</style>